import {
  GET_LIST_SUCCESS,
  // GET_ONE_SUCCESS,
  // CREATE_SUCCESS,
  DELETE_SUCCESS,
} from '@/state/types/data'

export default (resource, options) => (
  previousState = [],
  { type, payload, requestPayload, meta },
) => {
  if (!meta || meta.resource !== resource) {
    return previousState
  }
  switch (type) {
    // case GET_ONE_SUCCESS:
    //   return previousState.includes(requestPayload.id)
    //     ? previousState
    //     : [...previousState, requestPayload.id]
    // case CREATE_SUCCESS:
    //   return [...previousState, payload.data.id]
    case GET_LIST_SUCCESS:
      return Array.from(new Set(payload.data.map(record => record.id)))
    case DELETE_SUCCESS: {
      const index = previousState.findIndex(el => el == requestPayload.id) // eslint-disable-line eqeqeq
      if (index === -1) {
        return previousState
      }
      return [...previousState.slice(0, index), ...previousState.slice(index + 1)]
    }
    default:
      return previousState
  }
}

export const getIds = state => state



// WEBPACK FOOTER //
// ./state/reducers/resource/list/ids.js